import find from 'lodash/find';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { useGetLoggedInUser } from '@revelio/auth';
import { PagePaths, useTourStore } from '@revelio/core';
import type { KeyValueResp } from '@revelio/data-access';

import { hasCompletedTour } from '../../tour/use-is-tour-done';

export const useEnforceUserIntroduction = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    loggedInUser,
    realLoggedInUser,
    query: [{ fetching }],
  } = useGetLoggedInUser();

  useEffect(() => {
    // The following handles redirecting the user to landing to
    // start the user tour/view the tos, if user has not already completed it.

    if (fetching || isEmpty(loggedInUser)) {
      return;
    }

    const isTourRunning = useTourStore.getState().isTour;
    const tourStepIndex = useTourStore.getState().stepIndex;

    // not setting the default value here because get dosen't return
    // default value if metadata is null, which can lead to bugs.
    const metadata = get(loggedInUser, 'metadata') || [];
    const termsAccepted = find(metadata, {
      key: 'terms_accepted',
    }) as KeyValueResp;
    const isTourCompleted = hasCompletedTour(metadata);
    const isTermsAccepted = termsAccepted?.value === 'true';

    if (!isTourCompleted || !isTermsAccepted) {
      // only redirect user if the tour or ToS just launched
      if (
        isTourRunning &&
        tourStepIndex <= 1 &&
        location.pathname != PagePaths.LANDING
      ) {
        navigate(PagePaths.LANDING);
      }
    }
  }, [fetching, loggedInUser, location, navigate]);

  return { loggedInUser, realLoggedInUser, fetching };
};
